<template>
    <div class="space-y-1">
        <div class="grid grid-cols-5 gap-1">
            <form-button :color="hass.visible ? 'success' : 'theme'"
                title="Show or hide the Home Assistant flows of the active page (Shift+H)"
                @click="canvas.toggleMode('hass')">HA</form-button>
        </div>
        <div v-for="group in hass.palette" :key="group.id">
            <div class="mt-1 text-[10px] uppercase tracking-wide text-gray-300">{{ group.label }}</div>
            <div class="grid grid-cols-2 gap-1">
                <button v-for="entry in group.entries" :key="entry.id" type="button" draggable="true"
                    class="flex min-w-0 items-center gap-1 rounded px-1.5 py-0.5 text-left text-xs text-white shadow-sm hover:brightness-125"
                    :style="{ background: entry.color }"
                    :title="entry.title ?? entry.label"
                    @dragstart="onDragStart($event, entry)"
                    @click="$emit('add', entry)">
                    <span class="w-4 shrink-0 text-center">{{ entry.icon }}</span>
                    <span class="truncate">{{ entry.label }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useHassFlowStore } from '../../stores/hassFlowStore.js';
import { useCanvasModeStore } from '../../stores/canvasModeStore.js';
import { HASS_PALETTE_MIME } from '../graph/canvasGraphs.js';

/** Home Assistant flow nodes: click to add next to the selection, or drag onto the canvas. */
defineEmits(['add']);
const hass = useHassFlowStore();
const canvas = useCanvasModeStore();

function onDragStart(event, entry) {
    event.dataTransfer.setData(HASS_PALETTE_MIME, entry.id);
    event.dataTransfer.effectAllowed = 'copy';
}
</script>
